import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "overflow-auto" }
const _hoisted_3 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_4 = { class: "text-capitalize-first w-25" }
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { class: "text-capitalize-first" }
const _hoisted_7 = { class: "text-capitalize-first" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "d-flex justify-content-end align-items-center"
}
const _hoisted_18 = ["title", "onClick"]
const _hoisted_19 = ["title", "onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  colspan: "5",
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RequisiteGroupForm = _resolveComponent("RequisiteGroupForm")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("table", _hoisted_3, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.name')), 1),
                _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.req_count')), 1),
                _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.helper.trans('labels.active_req_count')), 1),
                _cache[5] || (_cache[5] = _createElementVNode("th", null, null, -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: ""
                }, [
                  _createElementVNode("td", null, [
                    (item.id)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.id), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (!item.id)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                          class: "form-control form-control-sm"
                        }, null, 8, _hoisted_10), [
                          [_vModelText, item.name]
                        ])
                      ]))
                    : (_ctx.currentEditGroup && _ctx.currentEditGroup.id === item.id)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentEditGroup.name) = $event)),
                            class: "form-control form-control-sm"
                          }, null, 512), [
                            [_vModelText, _ctx.currentEditGroup.name]
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(item.name), 1)),
                  _createElementVNode("td", null, _toDisplayString(item.requisitesCount), 1),
                  _createElementVNode("td", null, _toDisplayString(item.activeRequisitesCount), 1),
                  _createElementVNode("td", _hoisted_13, [
                    (!item.id || _ctx.currentEditGroup && _ctx.currentEditGroup.id === item.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (_ctx.saveRow(index)),
                            class: "btn btn-sm btn-outline-success text-nowrap me-2"
                          }, _cache[6] || (_cache[6] = [
                            _createElementVNode("i", { class: "fa fa-save" }, null, -1)
                          ]), 8, _hoisted_15),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (_ctx.cancel(index)),
                            class: "btn btn-sm btn-outline-dark text-nowrap"
                          }, _cache[7] || (_cache[7] = [
                            _createElementVNode("i", { class: "fa fa-cancel" }, null, -1)
                          ]), 8, _hoisted_16)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _withDirectives((_openBlock(), _createElementBlock("a", {
                            href: "#",
                            style: {"font-size":"150%"},
                            title: _ctx.helper.trans('labels.requisites_deactivate'),
                            onClick: _withModifiers(($event: any) => (_ctx.toggleRequisites(item.id, false)), ["prevent"])
                          }, _cache[8] || (_cache[8] = [
                            _createElementVNode("i", { class: "fa fa-toggle-off text-secondary" }, null, -1)
                          ]), 8, _hoisted_18)), [
                            [
                              _directive_b_tooltip,
                              void 0,
                              void 0,
                              { hover: true }
                            ]
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("a", {
                            href: "#",
                            class: "me-2 ms-2",
                            style: {"font-size":"150%"},
                            title: _ctx.helper.trans('labels.requisites_activate'),
                            onClick: _withModifiers(($event: any) => (_ctx.toggleRequisites(item.id, true)), ["prevent"])
                          }, _cache[9] || (_cache[9] = [
                            _createElementVNode("i", { class: "fa fa-toggle-on text-success" }, null, -1)
                          ]), 8, _hoisted_19)), [
                            [
                              _directive_b_tooltip,
                              void 0,
                              void 0,
                              { hover: true }
                            ]
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (_ctx.edit(item)),
                            class: "btn btn-sm btn-outline-dark text-nowrap me-2"
                          }, _cache[10] || (_cache[10] = [
                            _createElementVNode("i", { class: "fa fa-pencil" }, null, -1)
                          ]), 8, _hoisted_20),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (_ctx.remove(item)),
                            class: "btn btn-sm btn-outline-danger text-nowrap"
                          }, _cache[11] || (_cache[11] = [
                            _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                          ]), 8, _hoisted_21)
                        ]))
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("tfoot", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_22, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.add())),
                    class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize-first w-100"
                  }, [
                    _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fa fa-plus" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.add')), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.isTrader || _ctx.isTraderOperator)
        ? (_openBlock(), _createBlock(_component_b_modal, {
            key: 0,
            title: _ctx.createModalTitle,
            modelValue: _ctx.createModal,
            "body-class": "pt-0",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.createModal = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_RequisiteGroupForm, { ref: "createForm" }, null, 512)
            ]),
            footer: _withCtx(() => [
              (_ctx.isTrader || _ctx.isTraderOperator)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createModal = false)),
                    class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                  }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_LoaderWrapper, {
                ref: "loaderCreateFrom",
                zoom: 0.5
              }, {
                default: _withCtx(() => [
                  (_ctx.isTrader || _ctx.isTraderOperator)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveModal && _ctx.saveModal(...args))),
                        class: "btn btn-outline-primary btn-sm text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.save')), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          }, 8, ["title", "modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}